import { ProductVariant } from '../types';
import appStore from '../utils/state';

export default class OutOfStockButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;
  private json: HTMLScriptElement | null = null;
  private variant: ProductVariant | null = null;
  private onClickBound = this.onClick.bind(this);

  connectedCallback(): void {
    this.button = this.querySelector('[data-out-of-stock-button-ref="button"]');
    this.json = this.querySelector('[data-out-of-stock-button-ref="json"]');

    if (this.json) {
      this.variant = JSON.parse(this.json.textContent as string);
    }

    this.addEventListeners();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  onClick(): void {
    if (!this.variant) {
      return;
    }

    const variantInput = document.querySelector<HTMLInputElement>('#klaviyo-bis-variant-id');
    if (variantInput) {
      variantInput.value = this.variant.id.toString();
    }

    const klaviyoBtn = document.querySelector<HTMLElement>('.klaviyo-bis-injected-btn');
    if (klaviyoBtn) {
      klaviyoBtn.click();
    } else {
      appStore.actions.openOutOfStockModal(this.variant);
    }
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('out-of-stock-button', OutOfStockButton);
